<div
  tooltipClass="default-tooltip"
  class="relative flex items-center font-main text-sm overflow-hidden background w-full {{ buttonBackgroundClass }} {{ buttonBorderClass }}"
  [ngClass]="{
    'h-6': verticalSize === 'small',
    'h-8': verticalSize === 'medium',
    'cursor-default': isReadOnly,
    'cursor-pointer': !isReadOnly,
    'px-3': horizontalSize === 'small',
    'px-4': horizontalSize === 'medium',
    'rounded-full': radius === 'large',
    'rounded-md': radius === 'small'
  }">

  @if (buttonIcon && !isReadOnly) {
    <svg-icon [ngClass]="iconClasses" [src]="buttonIcon"></svg-icon>
  }

  <span
    class="flex-1 whitespace-nowrap overflow-hidden overflow-ellipsis"
    [ngClass]="textClasses"
    [ngbTooltip]="tooltip"
    tooltipClass="default-tooltip {{ tooltipClasses }}"
    [placement]="tooltipPlacement"
    [openTooltipWhenOverflowedAndHovered]="true"
    [openOnWidthOverflow]="true"
    [keepOnHover]="keepTooltipOnOver">
    <ng-content></ng-content>
  </span>

  @if (arrowEnabled && !isReadOnly) {
    <svg-icon
      class="arrow-icon ml-1.5 h-3 transform rotate-180"
      [ngClass]="{ 'transform rotate-180': isOpen, 'black-arrow': arrowBlackColor, 'text-inherit': !arrowBlackColor }"
      [src]="'arrow-down'"
    ></svg-icon>
  }
</div>
